import React, { useState } from 'react';
import send from '../design/send-main.png';
import {auth, firebase, db} from '../firebase.js';

function Footer() {
    const [msg, setMsg] = useState('');

    const handleChange = (e)=> {
        setMsg(e.target.value);
    }

    const sendMsg = ()=> {
        if(msg != '')
        {
            var msgRef = db.collection("messages");
            msgRef.doc().set({
            msg: msg,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            uid: auth.currentUser.uid,
            photoUrl: auth.currentUser.photoURL,
            name: auth.currentUser.displayName
            });
            setMsg('');
            document.getElementById("chatbox").scroll({top:0,behavior:'smooth'});
        }
    }

    function handleEnter(event) {
        if (event.keyCode === 13) {
          sendMsg();
        }
    }
    var disable = msg === '' ? 'disable' : 'true';

    return (
        <footer className="footer">
                <input type="text" placeholder="Type something..." value={msg} onKeyUp={handleEnter} autoFocus onChange={handleChange}/>
                <button className={`send ${disable}`} onClick={sendMsg}><img src={send}/></button>
        </footer>
    )
}

export default Footer;